module.exports = __webpack_public_path__ + "img/emoji_92.700f6ed8.png";